module.exports = __webpack_public_path__ + "static/media/DTSA-2022-LOGO.d8e17d23.png";